import React, { useContext, useState } from 'react';
import { useUpdateRoleMutation } from '../../../services/SkillsManagement';
import { useDispatch } from 'react-redux';
import { UPDATE_ROLE } from '../../../Reducers/Actions';
import { SnackBarContext } from '../../../Context/SnackBarContextProvider';
import EditIcon from '@mui/icons-material/Edit';
import { MenuItem, ListItemIcon, ListItemText, Grid } from '@mui/material';
import MuiDialog from '../../../SystemDesign/MuiDialog';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormInput from '../../../SystemDesign/FormInput';
import FormSelect from '../../../SystemDesign/FormSelect';

const UpdateRole = ({ row }) => {
    const [updateRole] = useUpdateRoleMutation();
    const dispatch = useDispatch();
    const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
    const [close, setClose] = useState(false);

    const initialValues = {
        name: row.original.name,
    };

    const [formValues, setFormValues] = useState(initialValues);



    const formFields = [
        { type: 'text', name: 'name', label: 'Role name', required: true },
    ];

    const formValidationSchema = yup.object().shape({
        name: yup.string()
            .required("role name is required")
            .min(3, "role name must contain at least 3 characters"),
      
    });

    const handleSubmit = async (values, actions) => {
        try {
            const response = await updateRole({ 
                roleId: row.original.roleId, 
                roleUpdateSchema: values 
            }).unwrap();
            
            dispatch({ type: UPDATE_ROLE, payload: response.role.role });
            setInfoAlert({ severity: 'success', message: `Role ${values.name} updated successfully` });
            setOpenSnackBar(true);
            setClose(true);
        } catch (error) {
            setInfoAlert({ severity: 'error', message: error.data?.message || 'An error occurred while updating the role' });
            setOpenSnackBar(true);
        }
        actions.setSubmitting(false);
    };

    return (
        <MuiDialog
            icon={<EditIcon />}
            triggerButton={
                <MenuItem>
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Update</ListItemText>
                </MenuItem>
            }
            title="Update role"
            subtitle={`Update role ${row.original.name}`}
            content={
                <Formik
                    initialValues={formValues}
                    validationSchema={formValidationSchema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    enableReinitialize={true}
                    onSubmit={(values, actions) => {
              handleSubmit(values, actions);
            }}                >
                    {(formik) => (
                        <Form id="updateRoleForm">
                            <Grid container spacing={2} marginTop={2}>
                                {formFields.map((field, index) => (
                                    <Grid item size={{ xs: 12 }} key={index}>
                                        {field.type !== 'select' ? (
                                            <FormInput
                                                type={field.type}
                                                name={field.name}
                                                label={field.label}
                                                required={field.required}
                                                value={formik.values[field.name]}
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                    setFormValues({ ...formValues, [field.name]: e.target.value });
                                                }}
                                            />
                                        ) : (
                                            <FormSelect
                                                name={field.name}
                                                label={field.label}
                                                options={field.options}
                                                required={field.required}
                                                value={formik.values[field.name]}
                                                disabled={field.disabled}
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                    setFormValues({ ...formValues, [field.name]: e.target.value });
                                                }}
                                            />
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            }
            existAction={true}
            actionTitle="Update"
            actionType="submit"
            formId="updateRoleForm"
            onClose={close}
        />
    );
};

export default UpdateRole;
